import { render, staticRenderFns } from "./OutrosTiposPanel.vue?vue&type=template&id=53a4cf4e&scoped=true&"
import script from "./OutrosTiposPanel.vue?vue&type=script&lang=js&"
export * from "./OutrosTiposPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a4cf4e",
  null
  
)

export default component.exports